<template>
  <div>
    <ModalBackdrop
      :id="modalId"
      :transition-props="{ name: 'modal__fade' }"
      mode="show"
      class="home__mission-modal"
      @opened="open"
      @closed="close"
    >
      <ModalBackdropDialog
        aria-label="mission"
        class="home__mission-modal-container"
      >
        <div class="home__mission-modal-column">
          <div class="home__mission-modal-content">
            <div class="home__mission-modal-body">
              <!-- eslint-disable max-len -->
              <p class="home__mission-modal-copy">UNLIMITED Tennis Academy was born to help you become better. Human potential is unlimited. Your age doesn’t matter and where you’re from doesn’t matter. It doesn’t matter what you look like, or how much money you make. What matters is how bad you want it, and how hard you’re willing to work. We develop human potential; we promise to make you better.</p>
              <p class="home__mission-modal-copy">So what does better mean? Better means a better athlete, better means a better tennis player, and better most importantly means a better person. We see tennis as a metaphor for life. The game can teach you discipline, character, sportsmanship, problem solving, emotional intelligence and much more. And we … can teach you the game of tennis.</p>
              <!-- eslint-enable max-len -->
            </div>
            <ModalButton
              :controls="modalId"
              class="home__mission-modal-button-close--small"
            >
              <span class="access-hidden">Close</span>
              <CloseIcon class="home__close-icon"/>
            </ModalButton>
            <ModalButton
              :controls="modalId"
              class="home__mission-modal-button home__mission-modal-button-close--large"
            >
              <HomeModalButton>
                Close
              </HomeModalButton>
            </ModalButton>
          </div>
        </div>
      </ModalBackdropDialog>
    </ModalBackdrop>
    <div
      :class="expanded ? 'mission-expanded' : null"
      class="home-mission__overlay"
    />
    <div
      :class="expanded ? 'mission-expanded' : null"
      class="home-mission"
    >
      <div
        :class="expanded ? 'mission-expanded' : null"
        class="home-ticker__blade"
      />
      <div
        :class="expanded ? 'mission-expanded' : null"
        class="home-ticker__heading"
      >
        Unlimited
      </div>
      <div
        :class="expanded ? 'mission-expanded' : null"
        class="home-ticker__border-container"
      >
        <div class="home-ticker__border"/>
      </div>
      <div class="home-ticker__container">
        <TextTicker
          :class="expanded ? 'mission-expanded' : null"
          :items= "items"
        />
      </div>
      <ModalButton
        :controls="modalId"
        :class="expanded ? 'mission-expanded' : null"
        class="home__mission-modal-button home__mission-modal-button--open"
      >
        <HomeModalButton>
          Read Our Mission
        </HomeModalButton>
      </ModalButton>
    </div>
    <!-- eslint-disable max-len -->
    <ModalButton
      :controls="modalId"
      :class="expanded ? 'mission-expanded' : null"
      class="home__mission-modal-button home__mission-modal-button--open home__mission-modal-button--small"
    >
      <!-- eslint-enable max-len -->
      <HomeModalButton>
        Read Our Mission
      </HomeModalButton>
    </ModalButton>
  </div>
</template>
<script>
  import TextTicker from './TextTicker';
  import ModalButton from './ModalButton';
  import ModalBackdrop from './ModalBackdrop';
  import ModalBackdropDialog from './ModalBackdropDialog';
  import CloseIcon from './CloseIcon';
  import HomeModalButton from './HomeModalButton';

  export default {
    components: {
      TextTicker,
      ModalButton,
      ModalBackdrop,
      ModalBackdropDialog,
      CloseIcon,
      HomeModalButton,
    },
    props: {
      items: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        expanded: false,
      };
    },
    computed: {
      modalId() {
        return `modal-${this._uid}`;
      },
    },
    methods: {
      open() {
        this.expanded = true;
        this.$root.expanded = true;
      },
      close() {
        this.expanded = false;
        this.$root.expanded = false;
      },
    },
  };
</script>
<style
  lang="scss"
  scoped
>

.home-mission {
  position: relative;
  z-index: 7;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  height: 200px;

  &.mission-expanded {
    pointer-events: none;
    user-select: none;
  }

  @include breakpoint(phablet) {
    height: 500px;
  }
}

.home-ticker__heading {
  position: relative;
  z-index: 2;
  margin-top: 54px;
  font-size: 1.4rem;
  font-family: font-family(sans-serif);
  font-weight: font-weight(bold);
  text-transform: uppercase;
  text-align: center;
  color: color(white);
  opacity: 1;
  transform: translateY(0);
  transition-property: opacity transform;
  transition-timing-function: timing-function(accelerate);
  transition-duration: duration(fast);

  @include breakpoint(phablet) {
    font-size: 3.3rem;
  }

  &.mission-expanded {
    @include breakpoint(phablet) {
      opacity: 0;
      transform: translateY(-25%);
      user-select: none;
      pointer-events: none;
      transition-timing-function: timing-function(decelerate);
    }
  }
}

.home-ticker__blade {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 50%;
  width: 110px;
  height: 180px;
  transform: skewX(-45deg) translateX(-50%);
  background-color: color(bronze);
  user-select: none;
  pointer-events: none;
  transition-property: background-color;
  transition-timing-function: timing-function(accelerate);
  transition-duration: duration(fast);

  @include breakpoint(phablet) {
    width: 275px;
    height: 100%;
  }

  &.mission-expanded {
    background-color: color(red);
    transition-timing-function: timing-function(decelerate);
  }
}

.home-ticker__border-container {
  @include container;
  position: relative;
  z-index: 0;
  width: 100%;
  height: 50px;
  transition-property: opacity;
  transition-timing-function: timing-function(accelerate);
  transition-duration: duration(fast);

  @include breakpoint(phablet) {
    height: spacing(ticker);
  }

  &.mission-expanded {
    @include breakpoint(phablet) {
      opacity: 0;
      user-select: none;
      pointer-events: none;
      transition-timing-function: timing-function(decelerate);
    }
  }
}

.home-ticker__border {
  @include column;
  width: percentage(8 / 12);
  height: 100%;
  margin-right: auto;
  margin-left: auto;
  border: 1px solid color(light-grey);
}

.home-ticker__container {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  pointer-events: none;
  user-select: none;
}

.home-ticker {
  opacity: 1;
  transition-property: opacity transform;
  transition-timing-function: timing-function(accelerate);
  transition-duration: duration(fast);
  transform: translateY(0);

  &.mission-expanded {
    @include breakpoint(phablet) {
      opacity: 0;
      transform: translateY(-25%);
      user-select: none;
      pointer-events: none;
      transition-timing-function: timing-function(decelerate);
    }
  }
}

.home__mission-modal-button {
  padding: 10px 0;
  position: relative;
  z-index: 5;
  color: color(white);
  margin: 0 auto;
  outline: 0;

  &:before,
  &:after {
    content: '';
    position: absolute;
    color: currentColor;
    left: 5px;
    width: calc(100% - 10px);
    height: 2px;
    transform: scaleX(0);
    transition-property: transform;
    transition-timing-function: timing-function(accelerate);
    transition-duration: duration(fast);
  }

  &:after {
    bottom: 5px;
    transform-origin: left;
    border-bottom: 2px solid;
  }

  &:before {
    top: 5px;
    transform-origin: right;
    border-top: 2px solid;
  }

  &:hover,
  &:focus {
    &:before,
    &:after {
      transform: scaleX(1);
    }
  }

  @include breakpoint(phablet) {
    margin-top: spacing(base-delta);
  }
}

.home-mission__overlay {
  display: none;

  @include breakpoint(phablet) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    background-color: rgba(color(slate), 0.9);
    transition-property: opacity;
    transition-timing-function: timing-function(accelerate);
    transition-duration: duration(fast);

    &.mission-expanded {
      opacity: 1;
      transition-timing-function: timing-function(decelerate);
    }
  }
}

.home__mission-modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 20;
  width: 100%;
  height: 100%;
  background-color: rgba(color(slate), 0.9);

  @include breakpoint(phablet) {
    position: absolute;
    z-index: 10;
    background: none;
  }
}

.home__mission-modal-container {
  @include container;
}

.home__mission-modal-column {
  @include column;
  width: 100%;

  @include breakpoint(phablet) {
    margin-top: 225px;
    width: percentage(11 / 12);
    margin-left: auto;
    margin-right: auto;
  }

  @include breakpoint(tablet) {
    width: percentage(10 / 12);
    margin-top: 350px;
  }

  @include breakpoint(laptop) {
    width: percentage(8 / 12);
  }
}

.home__mission-modal-body {
  width: 100%;
  padding-top: spacing(base-delta);

  @include breakpoint(phablet) {
    padding-top: spacing(base-delta);
  }

  p + p {
    margin-top: spacing(base-gamma);
  }

  p {
    font-family: font-family(sans-serif);
    font-size: 1.5rem;
    line-height: 1.5;
    color: color(white);

    @include breakpoint(phablet) {
      font-size: 2rem;
    }
  }
}

.home__mission-modal-copy {
  font-family: font-family(sans-serif);
  font-size: 1.5rem;
  line-height: 1.5;
  color: color(white);

  @include breakpoint(phablet) {
    font-size: 2rem;
  }
}

.home__mission-modal-button--open {
  opacity: 1;
  transform: translateY(0);
  transition-property: opacity transform;
  transition-timing-function: timing-function(accelerate);
  transition-duration: duration(fast);
  visibility: hidden;
  pointer-events: none;
  user-select: none;

  @include breakpoint(phablet) {
    visibility: visible;
    pointer-events: all;
    user-select: all;
    margin-top: 0;
    margin-bottom: spacing(base-delta);
  }

  &.mission-expanded {
    @include breakpoint(phablet) {
      opacity: 0;
      transform: translateY(-25%);
      user-select: none;
      pointer-events: none;
      transition-timing-function: timing-function(decelerate);
    }
  }

  &.home__mission-modal-button--small {
    visibility: visible;
    pointer-events: all;
    user-select: all;

    @include breakpoint(phablet) {
      display: none;
    }
  }
}

.home__mission-modal-content {
  padding-top: spacing(base-zeta);

  @include breakpoint(phablet) {
    padding-top: 0;
  }
}

.home__mission-modal-button-close--large {
  display: none;

  @include breakpoint(phablet) {
    display: block;
  }
}

.home-video-close--wrapper {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.home__mission-modal-button-close--small {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
  background-color: color(bronze);
  outline: 0;

  &:hover,
  &:focus {
    transform: scale(0.95);
  }

  @include breakpoint(phablet) {
    display: none;
  }
}

.home__close-icon {
  width: 25px;
  height: 25px;
  fill: color(white);
}

.access-hidden {
  @include access-hidden;
}

.modal__fade-enter-active {
  transition-property: opacity transform;
  transition-timing-function: timing-function(accelerate);
  transition-duration: duration(fast);
}

.modal__fade-leave-active {
  transition-property: opacity transform;
  transition-timing-function: timing-function(decelerate);
  transition-duration: duration(fast);
}

.modal__fade-enter,
.modal__fade-leave-to {
  opacity: 0;
}
</style>
